import { CardCategories, CardModel } from "src/swagger/api.client.generated";

export class CardPickerDialogOptions {
  selectionOption: SelectionOption;
  selectionType: SelectionType;
  selectedCards: number[] = [];
  dayPeriodId: number;
  deckTypeId: number;
  maxAngelCards?: number;
  lockPeriodSelectorToId?: number;
  hideActions?: boolean;
  disableSelection?: boolean;
}

export class CardCategoryGroup {
  category: CardCategories;
  categoryIcon: string;
  cards: CardModel[];
  expanded: boolean;
  visible: boolean;
}

export enum SelectionType {
  Activity = 1,
  Angel = 2,
  All = 3,
}
export enum SelectionOption {
  Single,
  Multiple,
}

export enum SortingOption {
  NameAsc = 0,
  NameDesc = 1,
  DateAddedAsc = 2,
  DateAddedDesc = 3,
  CategoryThenName = 4,
  ActivityMandatoryFirst = 5,
}

export enum FilterOption {
  None = 1,
  Custom = 2,
  Favorites = 3,
  Body = 4,
  Experiences = 5,
  Feelings = 6,
  Novelty = 7,
  Relationships = 8,
  Thoughts = 9,
}

export class FilterOptionWithSvg {
  option: FilterOption;
  displayText: string;
  svgPath: string;
  selectedClass: string;
}

export const STANDARD_FILTER_OPTIONS: FilterOptionWithSvg[] = [
  {
    option: FilterOption.Favorites,
    displayText: "Favourites",
    svgPath: "/assets/icons/icon-favorite.svg",
    selectedClass: "icon-beautyberry",
  },
  {
    option: FilterOption.Custom,
    displayText: "Custom",
    svgPath: "/assets/icons/icon-edit.svg",
    selectedClass: "icon-glacier",
  },
];

export const CATEGORY_FILTER_OPTIONS: FilterOptionWithSvg[] = [
  {
    option: FilterOption.Body,
    displayText: "Body",
    svgPath: "/assets/card-images/safety-cards/sc-body.svg",
    selectedClass: "icon-body",
  },
  {
    option: FilterOption.Experiences,
    displayText: "Experiences",
    svgPath: "/assets/card-images/safety-cards/sc-experiences.svg",
    selectedClass: "icon-experiences",
  },
  {
    option: FilterOption.Feelings,
    displayText: "Feelings",
    svgPath: "/assets/card-images/safety-cards/sc-feelings.svg",
    selectedClass: "icon-feelings",
  },
  {
    option: FilterOption.Novelty,
    displayText: "Novelty",
    svgPath: "/assets/card-images/safety-cards/sc-noveltyplay.svg",
    selectedClass: "icon-noveltyplay",
  },
  {
    option: FilterOption.Relationships,
    displayText: "Relationships",
    svgPath: "/assets/card-images/safety-cards/sc-relationships.svg",
    selectedClass: "icon-relationships",
  },
  {
    option: FilterOption.Thoughts,
    displayText: "Thoughts",
    svgPath: "/assets/card-images/safety-cards/sc-thoughts.svg",
    selectedClass: "icon-thoughts",
  },
];
